/**
 * Consents to send by default to account
 */
const CONSENTS_DEFAULT_CHEETAH = [
  16,
  17,
  18,
];

export default CONSENTS_DEFAULT_CHEETAH;
